import React from 'react'

const EMCtestReceivers = () => {
    return (
        <>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Rohde & Schwarz</a>
                        <i class="fa fa-angle-right"></i>
                        <a href="/">EMC Test Equipments
                        </a>
                        <i class="fa fa-angle-right"></i>
                        <span>EMC Test Receivers </span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div>
                    <h1 className='text-center ' style={{ textDecoration: "underline" }}>EMC Test Receivers </h1>
                </div>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/emctestReceiver.jpg' width={400} ></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>R&S®ESW, ESR, ESRP, EPL, ESL Series :</h2>
                        <p class="mbot25">
                            <ul>
                                <li>
                                    Description: The R&S®ESL combines an EMI test receiver and a spectrum analyzer in
                                    one instrument, making it versatile for diverse lab applications and EMI analysis.
                                </li>
                                <li>
                                    Frequency range: 1 Hz to 3 / 6 GHz
                                </li>
                                <li>Displayed average noise level: -169 dBm</li>
                                <li>Max. analysis bandwidth:  1 Hz to 20 MHz in zero span.</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EMCtestReceivers
